var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.year)+" Tous droits réservés par "),_c('b',[_vm._v("ittec-P&M")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }